var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"staff-back-button",on:{"click":_vm.goBack}},[_c('i',{staticClass:"fal fa-chevron-left mr-1"}),_vm._v(" "+_vm._s(_vm.$t('general.back', 'Back'))+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }